'use client';
import React, { createContext, useContext, useState, useRef, ReactNode } from 'react';

interface AskAiContextType {
  isOpen: boolean;
  openChat: () => void;
  closeChat: () => void;
  toggleChat: () => void;
}

const AskAiContext = createContext<AskAiContextType | undefined>(undefined);

export function useAskAi(): AskAiContextType {
  const context = useContext(AskAiContext);
  if (!context) {
    throw new Error('useAskAi must be used within an AskAiProvider');
  }
  return context;
}

interface AskAiProviderProps {
  children: ReactNode;
}

export function AskAiProvider({ children }: AskAiProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const openChat = () => {
    setIsOpen(true);
  };

  const closeChat = () => {
    setIsOpen(false);
  };

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const value: AskAiContextType = {
    isOpen,
    openChat,
    closeChat,
    toggleChat,
  };

  return (
    <AskAiContext.Provider value={value}>
      {children}
    </AskAiContext.Provider>
  );
}